import { render, staticRenderFns } from "./Invoker.vue?vue&type=template&id=b2e8c9cc&scoped=true"
import script from "./Invoker.vue?vue&type=script&lang=ts"
export * from "./Invoker.vue?vue&type=script&lang=ts"
import style0 from "./Invoker.vue?vue&type=style&index=0&id=b2e8c9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e8c9cc",
  null
  
)

export default component.exports